import React, { Component } from 'react';
import { connect } from 'react-redux';
import { animateScroll } from 'react-scroll';
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { get, isEmpty, upperCase } from 'lodash';
import TravellersAddresses from '../../../TravellersAddress/TravellersAddress';
import AdjustmentFieldTitle from '../Fields/AdjustmentFieldTitle/AdjustmentFieldTitle';
import TextArea from '../../../../../content/components/TextArea/TextArea';
import { FormGroup, ControlLabel, Col } from 'react-bootstrap';
import { CommunicationsMarketingSection } from '../../../CommunicationsMarketingSection';
import { isBroker, isBrokerOrganisation } from '../../../../../auth/redux/authActions';
import './styles/TabContent.scss';
export class ReviewDetailsTab05 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postcode: '',
      isChannel: '',
      error: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const nextPostCodeValues = get(
      nextProps.formValues,
      'data.attributes.metadata.adults[0].address.postcode',
    );

    // Detect if there is a change from Original Postcode to present a message
    if (
      this.state.isChannel === false &&
      isPostCodeFromIsleOrChannel(nextPostCodeValues)
    ) {
      this.setState(() => ({ error: true }));
    } else if (
      this.state.isChannel === true &&
      !isPostCodeFromIsleOrChannel(nextPostCodeValues)
    ) {
      this.setState({ error: true });
    } else {
      this.setState({ error: false });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const { singleCalculation, selection } = this.props;
    if (nextState.error !== this.state.error) {
      singleCalculation(selection);
    }
  }

  componentDidMount() {
    const { dispatch, change, singleCalculation, selection, formValues } = this.props;
    const postcodeValues = get(
      formValues,
      'data.attributes.metadata.adults[0].address.postcode',
    );
    let postcode = upperCase(postcodeValues);
    if (!isPostCodeFromIsleOrChannel(postcodeValues)) {
      this.setState({
        isChannel: false,
      });
    } else {
      this.setState({
        isChannel: true,
      });
    }

    if (!this.props.mta) {
      scrollToTop();
    }
    dispatch(change('data.current_tab', 5));
    if (!isEmpty(selection)) {
      singleCalculation(selection);
    }
    this.setState({
      postcode: postcode,
    });
  }

  handleMarketingOptionsChange = (options) => {
    const { dispatch, change } = this.props;
    dispatch(change('data.attributes.metadata.adults[0].marketing_options', options));
  };

  handleCommunicationOptionsChange = (value, type) => {
    const { dispatch, change } = this.props;

    if (isBroker() || isBrokerOrganisation()) {
      const emailSelected = type === 'email' && value === true;

      if (emailSelected) {
        dispatch(change('data.attributes.metadata.communications.post', false));
      }
    }
  };

  render() {
    const {
      formValues,
      mta,
      goTab01,
      isMarketingEnabled,
      auth,
      isInsuranceMarketingOptionsEnabled,
      isHomeInsuranceMarketingEnabled,
      isCarInsuranceMarketingEnabled,
      change,
    } = this.props;

    const { error } = this.state;

    const loggedInUserEmail = get(auth, 'user.data.attributes.email', '');

    const renderEndorsements = () => {
      return (
        <div>
          <div className="endorsements-mta-box">
            <div className="endorsement-row clearfix endorsement">
              <div className="endorsement-form">
                <Field
                  name={'data.attributes.metadata.storage.endorsements[0].title'}
                  label="Title"
                  labelSize={1}
                  readOnly={isBroker()}
                  component={AdjustmentFieldTitle}
                />
                <Field
                  name={'data.attributes.metadata.storage.endorsements[0].content'}
                  label="Content"
                  labelSize={1}
                  readOnly={isBroker()}
                  component={TextArea}
                />
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="review-details-section">
        <FormGroup>
          <Col sm={12}>
            <ControlLabel>
              <h4>Review Details Page</h4>
            </ControlLabel>
          </Col>
        </FormGroup>

        {mta ? renderEndorsements() : null}
        <FieldArray
          name="data.attributes.metadata.adults"
          formValues={get(formValues, 'data.attributes.metadata.adults')}
          travellerGroup={get(formValues, 'data.attributes.metadata.traveller_group')}
          leadAddress
          dobReadOnly
          change={change}
          goTab01={goTab01}
          disableAgeField
          postCodeReviewError={error}
          postCodeReviewMessage={`Please note: this change will effect your premium
                (Residents of the Isle of Man / Channel Islands are exempt from IPT)`}
          component={TravellersAddresses}
          loggedInUserEmail={loggedInUserEmail}
          // disableAddressFields={true}
        />
        <FieldArray
          name="data.attributes.metadata.children"
          formValues={get(formValues, 'data.attributes.metadata.children')}
          travellerGroup={get(formValues, 'data.attributes.metadata.traveller_group')}
          dobReadOnly
          goTab01={goTab01}
          change={change}
          child
          component={TravellersAddresses}
        />

        <div className="divider margin-bottom" />
        <CommunicationsMarketingSection
          onMarketingOptionsChange={this.handleMarketingOptionsChange}
          onCommunicationOptionsChange={this.handleCommunicationOptionsChange}
          isMarketingEnabled={isMarketingEnabled}
          isInsuranceMarketingOptionsEnabled={isInsuranceMarketingOptionsEnabled}
          isHomeInsuranceMarketingEnabled={isHomeInsuranceMarketingEnabled}
          isCarInsuranceMarketingEnabled={isCarInsuranceMarketingEnabled}
          marketingOptions={
            formValues?.data?.attributes?.metadata?.adults?.[0]?.marketing_options ?? []
          }
        />
        <div className="divider margin-bottom" />
      </div>
    );
  }
}

const isPostCodeFromIsleOrChannel = (postcode) => {
  const postcodeUpper = upperCase(postcode);
  return (
    postcodeUpper?.startsWith('JE') ||
    postcodeUpper?.startsWith('GY') ||
    postcodeUpper?.startsWith('IM') ||
    postcodeUpper?.startsWith('EV')
  );
};

const scrollToTop = () => {
  const scroll = animateScroll;
  scroll.scrollTo(30);
};
const FORM_NAME = 'LeisureTravelForm';

const form = reduxForm({ form: FORM_NAME })(ReviewDetailsTab05);
const selector = formValueSelector(FORM_NAME);
const mapStateToProps = (state) => {
  const values = selector(state, 'data.current_tab', 'data.attributes.metadata');

  return {
    updateBolton: state.boltons,
    auth: state.auth,
    initialValues: values,
    form: 'LeisureTravelForm',
    formValues: values,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    product: state.product,
    channel: state.channel,
  };
};

export default connect(mapStateToProps)(form);
